<template lang='pug'>
.page
  .page-content
    #cloneelements.hidden
      a#callNumberButton.btn.btn-default.fullwidth(href='#', onClick='$("#numberpicker").modal("hide"); app.setNum(this.dataset.number)')

      // Modal which allows pasting of numbers I think?? (rich)
      // Does this require a plugin?
      modal(name='numberOptionsVisible')
        .container
          <br>
          input(type="text" v-model="pastedNumber" placeholder="paste here" class="form-control" style="height:80px")
          <br>
          button.float-left.btn.btn-primary(active @click="pasteNumber(); hideModal('numberOptionsVisible');") Paste
          button.float-right.btn.btn-danger(@click="hideModal('numberOptionsVisible');" active) Cancel
    #dialerpad.block(v-if="!showDirectory")
      .number-row
        .valign
          span#number(x-apple-data-detectors="false" @click="clipboardPopup();") {{ number | phoneNumber | emptySpace}}
      .keyset-row
        button.square.key(type='button', data-value='1', @click='press("1")', ontouchend='click(); return false;')
          .bignum 1
          .lilnum &nbsp;
        button.square.key(type='button', data-value='2', @click='press("2")', ontouchend='click(); return false;')
          .bignum 2
          .lilnum ABC
        button.square.key(type='button', data-value='3', @click='press("3")', ontouchend='click(); return false;')
          .bignum 3
          .lilnum DEF
      .keyset-row
        button.square.key(type='button', data-value='4', @click='press("4")', ontouchend='click(); return false;')
          .bignum 4
          .lilnum GHI
        button.square.key(type='button', data-value='5', @click='press("5")', ontouchend='click(); return false;')
          .bignum 5
          .lilnum JKL
        button.square.key(type='button', data-value='6', @click='press("6")', ontouchend='click(); return false;')
          .bignum 6
          .lilnum MNO
      .keyset-row
        button.square.key(type='button', data-value='7', @click='press("7")', ontouchend='click(); return false;')
          .bignum 7
          .lilnum PQRS
        button.square.key(type='button', data-value='8', @click='press("8")', ontouchend='click(); return false;')
          .bignum 8
          .lilnum TUV
        button.square.key(type='button', data-value='9', @click='press("9")', ontouchend='click(); return false;')
          .bignum 9
          .lilnum WXYZ
      .keyset-row
        button.square.key(type='button', data-value='*', @click='press("*")', ontouchend='click(); return false;')
          .bignum *
          .lilnum P(,)
        button.square.key(type='button', data-value='0', @click='press("0")', ontouchend='click(); return false;')
          .bignum 0
          .lilnum +
        button.square.key(type='button', data-value='#', @click='press("#")', ontouchend='click(); return false;')
          .bignum #
          .lilnum &nbsp;
      .keyset-row
        button#contactsbutton.square.fn(type='button', @click="$router.push('/directory')", ontouchend='click(); return false;')
          span
            font-awesome-icon(icon='address-book')
        button#dial.square.fn(type='button', @click="dial", :class='{ pulsating: pulsating }', ontouchend='click(); return false;')
          span
            font-awesome-icon(icon='phone')
        button#del.square(type='button', @click='del', ontouchend='click(); return false;')
          span
            font-awesome-icon(icon='backspace')
  v-dialog(v-model='session' width=500 persistent)
    v-card
      v-card-title 
        center {{ number }}
      v-card-text
        v-row
          v-col(cols=4 v-for='n of ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"]' :key='n')
            v-btn(@click='$sip.dtmf(n)') {{ n }}
      v-card-actions
        v-btn(@click='$sip.bye') Hang Up


</template>

<script >
import Common from '../mixins/common.vue';

export default {
  // components: { Icon },
  mixins: [Common],
  components: {
  },
  data: function() {
    return {
      pulsating: false,
      clipboardText: "",
      contact: { phonenumbers: {} },
      contacts: {},
      directory: {},
      groups: [],
      showDirectory: false,
      pastedNumber: "",
    };
  },
  computed: {
    number: {
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
    useVOIP: {
      get() { return this.$store.state.useVOIP },
    },
    session: {
      get() {
        return this.$store.state.sip.session
      },
    }
  },
  watch: {
    number: function() { this.resizeNumber(); },
    showContactPopUp: function() {
      if (!this.showContactPopUp) {
        this.hideModal('directory');
      }
    },
  },
  methods: {

    clipboardPopup: function() {
      this.showModal('numberOptionsVisible');
    },
    press: function(chars) {
      // Add the chars to the number
      this.number += chars;
    },
    selectExtension: function(extension) {
      this.number = extension;
      this.showDirectory = false;

    },
    onOpen: function () {
        this.sorting = !this.sorting;
      },
    onClose: function () {
      this.sorting = !this.sorting;
    },
    del: function() {
      this.number = this.number.substring(0, this.number.length-1)
    },
    dial: function() {
      if (this.useVOIP) {
        console.log("Making call with SIP");
        console.log(this);
        this.$sip.dial(this.number);
      } else {
        this.$http.get(
            global.apiurl + "/clicktocall&" +
            "token=" + encodeURIComponent(this.click2call) +
            "&number=" + encodeURIComponent(this.number)
        );
      }

      this.pulsating=true;
      setTimeout(()=>{ this.pulsating=false; }, 5000);
    },
    showModal: function(name) {
      this.$modal.show(name);
    },
    showTheDirectory: function() {
      this.$router.push('/directory');
    },
    hideModal: function(name) {
      this.$modal.hide(name);
    },

    showContactVisible: function() {
      this.showModal('contactVisible')
    },
    //showDirectory: function() {
    //  this.updateDirectory();
    //  this.showModal('directory');

    //},
    cancelContact: function() {
      this.hideModal('directory');
    },
    pasteNumber: function() {
      //var textEl = this.$el.querySelector("#number");
      this.number = this.pastedNumber;
      this.resizeNumber();

    },
    resizeNumber: function() {
      this.$nextTick( ()=>{
        var textEl = this.$el.querySelector("#number");
        var width = textEl.offsetWidth

        if (width==0) {
          setTimeout(this.resizeNumber, 250);
        }

        // scale the element to be 80% of the size of it's containing el
        var vw100 = document.documentElement.clientWidth;

        textEl.style.fontSize = '8vh';

        var scale = 0
        if (width > ( vw100 *.8)) {
          scale = ( vw100 * .8 ) / width;
        } else {
          scale = 1;
        }

        var fs = 8 * scale;
        textEl.style.fontSize = '' + fs +'vh';
      } );
    },
  },
  mounted() {
    this.resizeNumber();
  },
  filters: {
      phoneNumber: function(value) {
        return value
                //.replace(/[^0-9]/g, '')
                .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3')
                .replace(/^(\d{1})(\d{3})(\d{3})(\d{4})$/, '$1 ($2) $3-$4');
      },
      emptySpace: function(value) {
        if (value == "") {
          return "- - -";
        } else {
          return value;
        }
      },
  },
}


</script>

<style scoped>
.fa-icon {
  width: auto;
  height: 1em; /* or any other relative font sizes */
}
body {
  margin: 0;
  border: 0;
  padding: 0;
  overflow: hidden;
}


/*
.fn {
  background-color: #e80 !important; // UI guidelines
}
*/

.event.listening {
    display:block;
}

.event.received {
    display:none;
}

.number-row {
  height: calc((100vh - 40px) / 6);
  width: 100%;
  text-align: center;
  /* background-color: #ccd; // UI GUidelines */
}

#number {
  width: 100vw;
  height: calc((100vh - 40px) / 6);
  text-align: center;
  font-size: 12vh;
  padding: 0;
  border: 0;
  white-space: nowrap;
}

.bignum {
  font-size: 6vh;
  text-shadow: .3vh .3vh #999;
}

.lilnum {
  font-size: 2vh;
}

div[class*="col-"] {
  background: #ffffff;
  text-align: center;
  color: #000;
  border: 0px solid #ddd;
  padding: 5px;
}
.row {
  margin-bottom: 15px;
}


.valign {
  top: 50%;
  position: relative;
  -moz-transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.square {
  border: 1px solid #999;
  float: left;
  height: calc((100vh - 40px) / 6);
  padding: 0;
  text-align: center;
  width: calc(100% / 3);

}

.halfsquare {
  border: 1px solid #999;
  float: left;
  font-weight: bold;
  height: calc((100vh - 40px) / 6);
  width: calc(100% / 6);
  padding: 0;
  text-align: center;
}


.key {
  touch-action: manipulation;
  -ms-touch-action: manipulation;
}

.keyset-row:after {
  clear: both;
  content: "";
  display: table;
}

.keyset-row {
  font-size: 4vh;
  font-weight: bold;
}

.square,
.halfsquare,
.numberrow {
  background-color: #fff;
}

.noselect,
.square,
.halfsquare,
.number-row {
  user-select: none !important;

  /* Enable this in browsers that have it as an experimental feature
     (all of them) */
  -webkit-user-select: none !important;
  -khtml-user-select: none !important;
  -moz-user-select: none !important;
  -ms-user-select: none !important;
  -o-user-select: none !important;
  white-space: pre;
}

.fullwidth {
  width: 100%;
}

.pulsating {
  animation: pulse 2s 4;
}

.right {
  position:absolute;
  right:13px
}


@keyframes pulse {
  0% {
    background-color: #fff;
  }
  50% {
    background-color: #9f9;
  }
  100% {
    background-color: #fff;
  }
}

#dialerpad {
  bottom: 0px;
  position: fixed;
  width: 100vw;
  padding: 0px;
  margin: 0;
}
</style>
